export default __webpack_public_path__ + "static/media/catch.e230ce4d.png";